/**
 * Creates a simple pub/sub system. Currently, it just calls each listener
 * with no arguments. To optimize in the future, we could extend this to allow
 * only listening to certain events. For example, different landing page
 * settings don't need to be notified when a landing page element changes, so
 * they wouldn't subscribe to that event.
 */
const createDispatcher = () => {
  let listeners = []

  const subscribe = fn => {
    listeners.push(fn)

    return () => {
      listeners = listeners.filter(listener => listener !== fn)
    }
  }

  const dispatch = () => {
    listeners.forEach(fn => fn())
  }

  return { subscribe, dispatch }
}

const Template = (
  { name: initialName, url: initialUrl, format: initialFormat },
  dispatch
) => {
  let name = initialName
  let url = initialUrl
  let format = initialFormat

  const change = ({ name: newName, url: newUrl, format: newFormat }) => {
    name = newName
    url = newUrl
    format = newFormat
    dispatch()
  }

  return {
    get name() {
      return name
    },
    get url() {
      return url
    },
    get format() {
      return format
    },
    change
  }
}

/**
 * A state object for a form or landing page (container).
 *
 * == Usage
 * const container = Container({ id, template })
 *
 * // change the template
 * container.template.change({ name: "academy", url: "pages.convertkit.com/templates/academy" })
 */
const Container = ({ id, template: initialTemplate, htmlBlocksAllowed }) => {
  let { subscribe, dispatch } = createDispatcher()
  let template = Template(initialTemplate, dispatch)

  return {
    id,
    template,
    subscribe,
    htmlBlocksAllowed
  }
}

export default Container
